/*
  Beweging: blokken schuiven rustig in beeld als je naar beneden scrolt.
  Michelle vond de 2.0-versie leuk omdat daar "meer beweegt".

  - Alleen elementen met .fts-in, plus de kolommen van de homepagekaarten.
  - Wat bij het laden al in beeld staat, blijft gewoon staan (geen flits).
  - Geen animatie bij 'verminder beweging', in de thema-editor, of als
    IntersectionObserver ontbreekt: dan is alles direct zichtbaar.
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var selector = ".fts-in, [id$='__kaarten'] .group-block";

  function start() {
    var items = Array.prototype.slice.call(document.querySelectorAll(selector));
    var hoogte = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-zichtbaar');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < hoogte) return; // staat al in beeld
      el.classList.add('fts-in', 'fts-in--wacht');
      // kaarten naast elkaar een fractie na elkaar
      el.style.transitionDelay = (i % 4) * 90 + 'ms';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
